import { Pagination } from "@mui/material";
import { Cross2Icon } from "@radix-ui/react-icons";
import { UserMultipleIcon } from "hugeicons-react";
import { Mail, Trash2 } from "lucide-react";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { useParams } from "react-router-dom";
import Select from "react-select";
import {
  ASSOSCIER_COORDO_PRESTATAIRE,
  COORDINATEUR_NON_ASSIGNE,
  COORDINATEURS_PRESTATAIRE,
  DISSOCIER_COORDINATEUR,
} from "../../Utils/constant";
import { deleteItem, find, store } from "../../services/service";

export const Coordonnateur = () => {
  const { id } = useParams();
  const coordo = [];
  const { handleSubmit, reset } = useForm();
  const [isSubmit, setIsSubmit] = useState(false);
  const [select, setSelect] = useState([]);
  const [listeCoordo, setListeCoordo] = useState([]);
  const [coordinateurs, setCoordinateurs] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loadingCoords, setLoadingCoords] = useState(false);
  const [coordToDelete, setCoorToDelete] = useState(null);

  const submit = (data) => {
    setIsSubmit(true);
    store(ASSOSCIER_COORDO_PRESTATAIRE, "application/json", {
      ...data,
      prestataireId: Number(id),
      coordinateurIds: select.map((item) => item.value),
    })
      .then((res) => {
        setIsSubmit(false);
        if (res.status === 200) {
          loadCoordinateurs(1);
          document.getElementById("associate_Coordo").close();
          reset();
          toast.success("Equipe enregistrée");
        }
      })
      .catch((err) => {
        setIsSubmit(false);
        toast.error(err.response.data.donnee);
      });
  };

  const getListeEquipe = async () => {
    await find(COORDINATEUR_NON_ASSIGNE + `/${id}`).then((res) => {
      setListeCoordo(res.data?.donnee);
    });
  };

  const loadCoordinateurs = async (page = 1) => {
    setLoadingCoords(true);
    try {
      const response = await find(
        `${COORDINATEURS_PRESTATAIRE}/${id}/coordinateurs?page=${
          page - 1
        }&size=8`
      );
      setCoordinateurs(response?.data?.donnee);
      setCurrentPage(page);
    } catch (err) {
      toast.error("Erreur lors du chargement des coordinateurs");
    } finally {
      setLoadingCoords(false);
    }
  };

  useEffect(() => {
    getListeEquipe();
    loadCoordinateurs(1);
  }, [id]);

  listeCoordo?.map((item) => {
    return coordo.push({ value: item.id, label: item.nomPrenoms });
  });

  const dissociateCoordinator = async (coordinateurId) => {
    setCoorToDelete(coordinateurId);
    document.getElementById("confirm_dissociate").showModal();
  };

  const confirmDissociate = async () => {
    try {
      const response = await deleteItem(
        `${DISSOCIER_COORDINATEUR}/${coordToDelete}/${id}`
      );
      if (response.status === 200) {
        toast.success("Coordonnateur dissocié avec succès");
        loadCoordinateurs(1);
        getListeEquipe();
        document.getElementById("confirm_dissociate").close();
        setCoorToDelete(null);
      }
    } catch (err) {
      toast.error(
        err.response?.data?.donnee || "Erreur lors de la dissociation"
      );
    }
  };

  const cancelDissociate = () => {
    document.getElementById("confirm_dissociate").close();
    setCoorToDelete(null);
  };

  const more = async (page) => {
    loadCoordinateurs(page);
  };

  return (
    <div className="">
      <>
        <dialog id="confirm_dissociate" className="modal rounded-none">
          <div className="modal-box w-10/12 max-w-md">
            <div className="modal-action">
              <h1 className="mr-auto text-xl font-bold font-mtn">
                Confirmer la dissociation
              </h1>
              <form method="dialog">
                <button className="btn btn-sm">
                  <Cross2Icon />
                </button>
              </form>
            </div>
            <div className="py-4">
              <p className="text-gray-700">
                Êtes-vous sûr de vouloir dissocier ce coordonnateur ?
              </p>
            </div>
            <div className="modal-action">
              <button
                onClick={cancelDissociate}
                className="btn btn-outline btn-sm"
              >
                Annuler
              </button>
              <button
                onClick={confirmDissociate}
                className="btn btn-error btn-sm text-white"
              >
                Dissocier
              </button>
            </div>
          </div>
        </dialog>

        <dialog id="associate_Coordo" className="modal rounded-none">
          <div className="modal-box w-10/12 max-w-xl h-3/5">
            <div className="modal-action">
              <h1 className="mr-auto text-2xl font-bold font-mtn">
                Associer un coordonnateur
              </h1>
              <form method="dialog">
                <button id="close_team" className="btn btn-sm">
                  <Cross2Icon />
                </button>
              </form>
            </div>
            <form onSubmit={handleSubmit(submit)} className="px-2">
              <div className="my-4 space-y-4">
                <div className="my-2">
                  <label htmlFor="" className="text-sm font-medium">
                    Coordonnateur <span className="text-red-500">*</span>
                  </label>
                  <Select
                    isMulti
                    onChange={(e) => setSelect(e)}
                    options={coordo}
                  />
                </div>

                <button
                  type="submit"
                  disabled={isSubmit ? true : false}
                  className={`${
                    !isSubmit
                      ? "text-black bg-main"
                      : "text-slate-800 bg-slate-200 "
                  } w-full my-3 hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-bold rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800`}
                >
                  {!isSubmit ? "Enregistrer" : "Veuillez patientez..."}{" "}
                  {isSubmit ? (
                    <span className="loading loading-dots loading-xs"></span>
                  ) : null}
                </button>
              </div>
            </form>
          </div>
        </dialog>

        <>
          <div className="flex items-center my-3">
            <input
              onChange={(e) => {}}
              type="text"
              placeholder="Recherche..."
              className="input input-bordered px-3 w-80 h-10 text-gray-900 placeholder:text-gray-400"
            />
            <div className="ml-auto flex items-center gap-2">
              <button
                onClick={() => {
                  document.getElementById("associate_Coordo").showModal();
                }}
                className="ml-auto btn btn-sm shadow-none bg-black text-white rounded-md"
              >
                Associer un coordonnateur
              </button>
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3">
            {coordinateurs?.map((item) => (
              <div
                key={item?.id}
                className="group relative flex flex-col gap-2 p-3 border border-gray-200 bg-white hover:border-amber-400 hover:shadow-md rounded-lg transition-all duration-200"
              >
                <button
                  onClick={() => dissociateCoordinator(item?.coordinateur?.id)}
                  className="absolute top-2 right-2 p-1.5 opacity-0 group-hover:opacity-100 transition-opacity bg-red-50 hover:bg-red-100 text-red-600 rounded-lg"
                  title="Dissocier ce coordonnateur"
                >
                  <Trash2 size={16} />
                </button>
                <div className="flex items-start gap-3">
                  <div className="bg-blue-100 group-hover:bg-blue-200 w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0 transition-colors">
                    <UserMultipleIcon size={20} className="text-blue-600" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-semibold text-gray-900 truncate">
                      {item?.coordinateur?.nomPrenoms}
                    </p>
                    <div className="flex items-center gap-1 mt-1">
                      <Mail className="w-3 h-3 text-gray-400 flex-shrink-0" />
                      <p className="text-xs text-gray-500 truncate">
                        {item?.coordinateur?.email || "Non renseigné"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="my-3 flex justify-end">
            <Pagination
              onChange={(event, newValue) => more(newValue)}
              onSelect={(selectedPage) => more(selectedPage)}
              count={coordinateurs?.totalPages || 0}
              page={currentPage}
              variant="outlined"
              color="primary"
              shape="rounded"
            />
          </div>
        </>
      </>
    </div>
  );
};
